import { MEDIA_TYPES } from '../constants';

const VIDEO_EXTENSIONS = ['mp4', 'm4v', 'm4p', 'webm', 'mkv', 'avi', 'mov', 'wmv', 'mpeg'];
const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'webp', 'svg'];
const APPLICATION_EXTENSIONS = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'tiff', 'tif', 'psd', 'psb'];

const getMediaTypeByFilename = (filename) => {
  const extension = filename.split('.').pop();

  if (VIDEO_EXTENSIONS.includes(extension)) {
    return MEDIA_TYPES.VIDEO;
  }

  if (IMAGE_EXTENSIONS.includes(extension)) {
    return MEDIA_TYPES.IMAGE;
  }

  if (APPLICATION_EXTENSIONS.includes(extension)) {
    return MEDIA_TYPES.APPLICATION;
  }

  return MEDIA_TYPES.APPLICATION;
};

export default getMediaTypeByFilename;
